module.exports = __webpack_public_path__ + "img/icon_lock.e90e6d86.svg";